// extracted by mini-css-extract-plugin
export var icon = "SectionIcon-module--icon--2UhIF";